import styled from 'styled-components'
import { DatePickerWrapper } from '../styled'

export const DatePickerMaskWrapper = styled.div`
	opacity: 0;
	height: 0;
	padding: 0;
	border: none;
`
export const CardMaskWrapper = styled(DatePickerWrapper)`
	* {
		height: 0px;
		visibility: hidden;
	}
	position: relative;
	input {
		display: none;
	}
`
